import { Params, useRequest } from "~/api/Request"
import API_V2 from "~/api/api-v2"
import { ValidateCSVRes } from "~/model/ImportCSV"

export function useImport() {
  const { Request } = useRequest()
  const importCheckContractCsv = (formData: Params) => {
    return Request.post<ValidateCSVRes>(API_V2.IMPORT_CHECK_CONTRACT_CSV, formData, {
      headers: {
        "content-type": "multipart/formdata",
      },
    })
  }
  const importContract = (dataNew: Params, dataUpdate: Params) => {
    return Request.post<ValidateCSVRes>(API_V2.IMPORT_CONTRACT, {
      dataNew,
      dataUpdate,
    })
  }

  return {
    importCheckContractCsv,
    importContract,
  }
}
